<template>
  <div class="flex flex-row-reverse justify-center items-center gap-[50px]">
    <!-- Card icon -->
    <div class="flex h-[233px] w-[375px] shadow-popup scale-125 m-[100px]">
      <img
          alt="card"
          class="w-full h-full object-contain"
          src="/src/assets/images/card.jpg"
      />
    </div>
    <div class="flex flex-col gal-[36px]">
      <!-- Form -->
      <div class="flex flex-col gap-[14px]">
        <input-default
            v-maska
            :error="v$.cardNumber.$error"
            :errorMessage="v$.cardNumber.$errors[0]?.$message"
            :label="'מספר אשראי'"
            :maxlength="19"
            :model-value="cardNumber"
            autocomplete="cc-number"
            class="text-dir-ltr"
            data-maska="#### #### #### ####"
            type="text"
            @update:model-value="setCardNumber"
        >
          <template v-slot:left_icon>
            <span class="material-symbols-rounded text-grays-700 text-[20px]"
            >credit_card</span
            >
          </template>
        </input-default>
        <div class="flex flex-row-reverse justify-end gap-[20px]">
          <div class="flex w-[100px]">
            <input-default
                v-maska
                :error="v$.cvv.$error"
                :errorMessage="v$.cvv.$errors[0]?.$message"
                :label="'CVV'"
                :maxlength="4"
                :model-value="cvv"
                :placeholder="''"
                :widthAuto="true"
                autocomplete="cc-csc"
                data-maska="####"
                type="text"
                @update:model-value="setCvv"
            >
              <template v-slot:label_icon>
                <div class="relative group">
                  <span
                      class="material-symbols-rounded text-grays-700 text-[16px]"
                  >error</span
                  >
                  <tooltip-cvv class="opacity-0 group-hover:opacity-100"/>
                </div>
              </template>
            </input-default>
          </div>
          <div class="flex w-[180px]">
            <input-default
                v-maska
                :error="v$.expirationDate.$error"
                :errorMessage="v$.expirationDate.$errors[0]?.$message"
                :label="'תוקף'"
                :maxlength="5"
                :model-value="expirationDate"
                :placeholder="''"
                :widthAuto="true"
                data-maska="##/##"
                type="text"
                @update:model-value="setExpirationDate"
            >
            </input-default>
          </div>
        </div>
        <input-default
            :error="v$.idNumber.$error"
            :errorMessage="v$.idNumber.$errors[0]?.$message"
            :model-value="idNumber"
            autocomplete="cc-number"
            label="תעודת זהות של בעל הכרטיס"
            type="text"
        >
        </input-default>
      </div>
    </div>
  </div>
</template>
<script>
import InputDefault from "@/components/Global/InputDefault.vue";
import TooltipCvv from "@/components/Global/TooltipCVV.vue";
import useValidate from "@vuelidate/core";
import {cardValidation} from "@/validation/Card";
import {mapGetters, mapMutations} from "vuex";

export default {
  name: "CompleteRegistrationPage2",
  components: {TooltipCvv, InputDefault},
  data() {
    return {
      v$: useValidate(),
      requestError: false,
    };
  },
  validations() {
    return {
      cardNumber: cardValidation.cardNumber,
      cvv: cardValidation.cvv,
      expirationDate: cardValidation.expirationDate,
      idNumber: cardValidation.idNumber,
    };
  },
  methods: {
    ...mapMutations({
      setCardNumber: "card/setCardNumber",
      setCvv: "card/setCvv",
      setExpirationDate: "card/setExpirationDate",
      setIdNumber: "card/setIdNumber",
    }),
    validateForm() {
      let isValid = false;
      this.v$.$validate();
      this.validateNewPhones = true;
      if (!this.v$.$error) {
        isValid = true;
      }
      return isValid;
    },
  },
  computed: {
    ...mapGetters({
      cardNumber: "card/getCardNumber",
      cvv: "card/getCvv",
      expirationDate: "card/getExpirationDate",
      idNumber: "card/getIdNumber",
    }),
  },
  watch: {
    cardData: {
      deep: true,
      handler(updatedData) {
        this.setCardNumber(updatedData.cardNumber);
        this.setExpirationDate(updatedData.expirationDate);
        this.setCvv(updatedData.cvv);
        this.setIdNumber(updatedData.idNumber);
      },
    },
  },
};
</script>

<style scoped>
</style>